export default __webpack_public_path__ + "static/Value-Dispersion-61271a8d1dd75e66527ebc4cedb39125.webp";